import TableLayout from "../../../layout/main/TableLayout";
import { Column, DText, Flex, Relative, Row } from "../../../../styles/CommonStyles";
import { formatNumber } from "../../../../core/utils/common";
import DateTime from "../../../common/utils/DateTime";
import useGetTableIndex from "../../../../core/hooks/layout/useGetTableIndex";
import { swapsAttributes } from "../../../../core/constants/headers";
import CopyText from "../../../common/utils/CopyText";
import { useNavigate } from "react-router-dom";

const SwapListingTable = ({ data, detail }) => {
    const { data: swaps } = data
    const { cs, headers } = swapsAttributes
    const { getTableIndex } = useGetTableIndex()
    const navigate = useNavigate()

    return (
        <TableLayout
            headers={headers}
            cs={cs}
            data={data}
        >
            {swaps?.data?.map((item, idx) => (
                <Relative key={item._id}>
                    <Row cs={cs} index={idx}>
                        <Column>{getTableIndex(idx)}</Column>
                        {/* User full name */}
                        <Column className="cursor-pointer" onClick={() => { navigate(`/users/${item.client?.userId}`) }}>
                            <DText main>
                                {item.user?.firstName} {item.user?.lastName}
                            </DText>
                        </Column>

                        {/* User ID */}
                        <Column>
                            <DText>
                                <CopyText text={item.client?.userId} maxWidth={'80px'} justify={'flex-end'} />
                            </DText>
                        </Column>

                        {/* Amount */}
                        <Column>
                            <DText>{formatNumber(item.amount)}</DText>
                        </Column>

                        {/* Wage */}
                        <Column>
                            <DText>{formatNumber(item.wage)}</DText>
                        </Column>

                        {/* Status */}
                        <Column>
                            <DText>{item.status}</DText>
                        </Column>

                        {/* Date */}
                        <Column>
                            <DateTime dt={item.createdAt} />
                        </Column>
                    </Row>
                </Relative>
            ))}
        </TableLayout>
    )
}

export default SwapListingTable
